import { State } from '@typings';

export const configSelector = (state: State) => state.config;
